import * as React from 'react';
import {connect} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import AppAction from '../../../reduxstore/actions/action';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import {FirebaseClient} from '../../../middleware/firebase';

interface IngresoProps {
    history?: any;
    dispatch: (action: AppAction) => (any);
    isAuthenticated: boolean;
    isLoading: boolean;
}

const mapStateToProps = (state) => {
    const stateProps = {
        isAuthenticated: state.app.getIsAuthenticated(),
        isLoading: state.app.getIsLoading()
    };
    return stateProps;
};

class IngresoView extends React.PureComponent<IngresoProps & RouteComponentProps<any>> {

    @lazyInject(TYPES.FIREBASE)
    public firebase: FirebaseClient;

    public componentDidUpdate(prevProps) {
        if (!this.props.isAuthenticated) {
            this.firebase.startFirebaseUi('#firebaseui-auth-container');
        }
    }

    public componentDidMount() {
        if (!this.props.isAuthenticated) {
            this.firebase.startFirebaseUi('#firebaseui-auth-container');
        }
    }

    public render() {
        return (
            this.props.isAuthenticated ? null : <div className='account'>
                <div className='account__wrapper'>
                    <div className='account__card'>
                        <div className='account__head'>
                            <h3 className='account__title'><span className='account__logo'><div
                                className='account__logo-accent'/></span></h3>
                            <h4 className='account__subhead subhead'>Control de Despacho</h4>
                        </div>
                        <div id='firebaseui-auth-container'/>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps)(IngresoView) as any);



// WEBPACK FOOTER //
// ./src/components/pages/ingreso/ingreso.tsx